import { Component, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { UserPreferencesFacade } from '@app/core/stores/user-preferences';

@Component({
    selector: 'topo-theme-switcher',
    imports: [NgTemplateOutlet],
    templateUrl: './theme-switcher.component.html',
    styleUrls: ['./theme-switcher.component.scss']
})
export class ThemeSwitcherComponent {
  protected userPref = inject(UserPreferencesFacade);
}
